// extracted by mini-css-extract-plugin
export default {"portable":"blog_portable__+OGNB","page-intro":"blog_page-intro__qWk1B"};